import React from 'react';
import { config } from '@/config/env';
import { EmbeddingContainer } from '@/features/embedding/components/EmbeddingContainer';
import { useShellI18n } from '@/features/language/useI18n';
import { useAuthorization } from '@/features/auth/hooks';

export const BookingPage: React.FC = () => {
  const { t } = useShellI18n();
  const { filterServices } = useAuthorization();
  const allServices = config().EMBEDDED_SERVICES || [];
  const service = filterServices(allServices).find((entry) => entry.id === 'booking');
  const configuredService = allServices.find((entry) => entry.id === 'booking');

  if (!service) {
    return (
      <section className="page-shell">
        <div className="empty-state">
          {configuredService
            ? t('Booking is not available for your account.')
            : t('Booking service is not configured in {{name}}.', { name: 'EMBEDDED_SERVICES' })}
        </div>
      </section>
    );
  }
  return (
    <section className="community-shell-screen">
      <EmbeddingContainer service={service} className="community-frame-wrap" />
    </section>
  );
};

export default BookingPage;
